import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Link, useMatch } from "react-router-dom"

import LanguageSwitcher from "../../components/LanguageSwitcher/LanguageSwitcher"
import ModelsDropDown from "../../components/ModelsDropDown/ModelsDropDown"
import { getSelectedModel } from "../../hooks/use-selected-model"

import { getCmsAssetsUrl } from "../../helpers/general"

import styles from "../Header/Header.module.scss"

const assetsUrl = getCmsAssetsUrl()

export default function MobileMenu() {
  const [menuOpen, setMenuOpen] = useState(false)
  const { t, i18n } = useTranslation()
  const isViewer = false
  const model = getSelectedModel()
  const home = useMatch("/" + i18n.language)
  const homeConfigure = useMatch("/" + i18n.language + "/configure")
  const summaryPage = useMatch(
    "/" + i18n.language + "/configure/" + model + "/summary"
  )

  return (
    <div className={styles.mobile}>
      <img
        src={`${assetsUrl}/images/ingeteamev/icons/hamburger.svg`}
        alt="Hamburger"
        className={styles.hamburgerIcon}
        onClick={() => setMenuOpen(!menuOpen)}
      />
      {menuOpen && (
        <div
          className={`${styles.dropdownMenu} ${menuOpen ? styles.open : ""}`}
        >
          {home !== null || homeConfigure !== null || summaryPage !== null ? (
            <div className={styles.modelsDropDown}>
              <ModelsDropDown />
            </div>
          ) : (
            ""
          )}
          {home !== null || summaryPage !== null ? (
            <div className={styles.configurateNowLink}>
              <Link
                className={styles.button}
                to={`/${i18n.language}/configure`}
              >
                {t("configurate now")}
              </Link>
            </div>
          ) : (
            ""
          )}
          {!isViewer && (
            <div className={styles.contentLang}>
              <img
                src={`${assetsUrl}/images/ingeteamev/icons/globe.svg`}
                alt="Globe"
                className={styles.globeIcon}
              />
              <LanguageSwitcher />
            </div>
          )}
        </div>
      )}
    </div>
  )
}
